import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import AuthService from '../services/authService';
import ApiService from '../services/apiService';
import { version } from '../../package.json';
import { Redirect } from 'react-router-dom';
import { CircularProgress } from '@rmwc/circular-progress';

import Dashboard from './dashboard';
import CTCTiming from './ctctiming';
import OPNR from '../pages/opnr';

import '@material/select/dist/mdc.select.css';
import '@material/floating-label/dist/mdc.floating-label.css';
import '@material/notched-outline/dist/mdc.notched-outline.css';
import '@material/line-ripple/dist/mdc.line-ripple.css';
import '@material/list/dist/mdc.list.css';
import '@material/menu/dist/mdc.menu.css';
import '@material/menu-surface/dist/mdc.menu-surface.css';

class Main extends Component {
  constructor(props) {
    super(props);

    console.info ('Hi!  This is version ' + version);
    this.state = {
      projectList: null,
      selectedProject: null,
    }

  }

  componentDidMount() {
    if (AuthService.isLoggedIn()) {
      ApiService.getProjectsList()
        .then((projectList) => {
          let params = new URLSearchParams(window.location.search);
          this.setState({
              projectList: projectList,
            }, () => {
              if (params.get('project')) {
                this.selectProject(params.get('project'));
              }
            });
        })
    }
  }

  selectProject(projNum) {
    let theProject = this.state.projectList.find(proj => proj.ProjNum.trim() === projNum.trim());
    let params = new URLSearchParams(window.location.search);
    params.set('project', theProject.ProjNum.trim());

    const newURL = new URL(window.location.href);
    newURL.search = params.toString();
    window.history.replaceState({ path: newURL.href }, '', newURL.href);


    this.setState({
      selectedProject: theProject
    })
  }

  projectDropdown() {
    let placeholder = 'Retrieving projects...';
    let icon = <CircularProgress />;
    let options = null;

    if (this.state.projectList) {
      placeholder = 'Select Project';
      icon = null;

      let sortedProjectList = this.state.projectList.filter(proj => proj.Stat === 'A');

      sortedProjectList.sort((a,b) => { 
        let aNum = parseInt(a.ProjNum.trim());
        let bNum = parseInt(b.ProjNum.trim());

        if (!isNaN(aNum) && !isNaN(bNum)) return aNum < bNum ? -1 : 1;
        else return a.ProjNum.trim().localeCompare(b.ProjNum.trim());
      });
      // if (AuthService.isFAMConfig) {
      //   sortedProjectList.sort((a,b) => { 
      //     let aString = a.ProjDesc.trim() + a.ProjNum.trim();
      //     let bString = b.ProjDesc.trim() + b.ProjNum.trim();
      //     return aString.localeCompare(bString)
      //   });
      // }
      options = sortedProjectList.map((element, index) => <option key={element.ProjNum} value={element.ProjNum}>{`${element.ProjNum.trim()} - ${element.ProjDesc}`}</option>);

      options.push(<option key='ArchivedDivider' value='' disabled>----------- Archived / Inactive -----------</option>);

      let sortedArchivedProjectList = this.state.projectList.filter(proj => proj.Stat !== 'A');
      sortedArchivedProjectList.sort((a,b) => { return parseInt(a.ProjNum.trim()) - parseInt(b.ProjNum.trim())});
      options = options.concat(sortedArchivedProjectList.map((element, index) => <option key={element.ProjNum} value={element.ProjNum}>{`${element.ProjNum.trim()} - ${element.ProjDesc}`}</option>));

      options.unshift(<option key='0' value='' disabled hidden>Select a project...</option>);
    }

    let selectedValue = this.state.selectedProject ? this.state.selectedProject.ProjNum : '';

    return <select className="dashboard-header-select" 
      label="Projects" placeholder={placeholder} icon={icon} value={selectedValue}
      onChange={(e) => this.selectProject(e.target.value)}>
        {options}
      </select>;

  }

  render() {
    if (AuthService.isLoggedIn()) {
      return (
        <>
        <div className="dashboard-header content-max-width">
          <label>Project:</label>{this.projectDropdown()}
        </div>
        <div>
          {this.state.selectedProject && 
            <Switch>
              <Route path="/opnr" render={() => <OPNR project={this.state.selectedProject} onExportDataset={(ds) => { if (this.props.onExportDataset) this.props.onExportDataset(ds); }}/>} />
              <Route path="/ctctiming" render={() => <CTCTiming project={this.state.selectedProject} onExportDataset={(ds) => { if (this.props.onExportDataset) this.props.onExportDataset(ds); }}/>} />
              <Route path="/costs" render={() => <Dashboard project={this.state.selectedProject} onExportDataset={(ds) => { if (this.props.onExportDataset) this.props.onExportDataset(ds); }}/>} />
              <Redirect from="/" to="/costs" exact />
            </Switch>
          }
        </div>
        </>
      );
    }
    else {
      if (AuthService.hasExpiredToken()) {
        AuthService.setSignOutReason('Your sign-in expired');
      }
      return (
        <Redirect to="/login" />
      )
    }
  }
}

export default Main;
